import { createStyles, makeStyles, Theme, createTheme } from '@material-ui/core/styles';

const defaultTheme = createTheme({});
const { pxToRem } = defaultTheme.typography;


export const tableUseStyles = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    bodyCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0.5px',
      height: '10px',
      minWidth: '100px',
    },
    bodyCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0.5px',
      height: '10px',
      minWidth: '100px',
      textAlign: 'center',
    },
    bodySelectCellCenter: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0.5px',
      height: '10px',
      minWidth: '100px',
      textAlign: 'center',
      backgroundColor: 'yellow',
    },
    bodyRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: '#7fffd4',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },
    },
  })
);


export const MeasureLogStyle = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 250px)',
    },
  })
);

export const FooterBaseStyle = makeStyles(
  createStyles({
    buttonStyle: {
      maxWidth: '180px',
      maxHeight: '35px',
      minWidth: '180px',
      minHeight: '35px',
    },
  })
);
